import { Tooltip } from '@servicetitan/design-system';

const ACTIVITY_BLOCKED_TOOLTIP = 'Unavailable users cannot receive calls';

/**
 * Wraps the radio cell content with a tooltip explaining why the row cannot
 * be selected when the user is blocked by activity.
 */
export const BlockedActivityTooltip: React.FC<{
  blocked: boolean;
  children: React.ReactElement;
}> = ({ blocked, children }) => {
  if (!blocked) return children;
  return (
    <Tooltip portal el='div' direction='top' text={ACTIVITY_BLOCKED_TOOLTIP}>
      {children}
    </Tooltip>
  );
};
